var _circle, _path, _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMusuem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1283_131)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 28L21.5 46H78L50 28Z",
    fill: "#393184"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 65,
    width: 54,
    height: 7,
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1283_131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2812 55.8872V66.5498H29.8491H33.417V55.8872V45.2246H29.8491H26.2812V55.8872ZM39.6013 55.8872V66.5498H43.1692H46.737V55.8872V45.2246H43.1692H39.6013V55.8872ZM53.3971 55.8872V66.5498H56.9649H60.5328V55.8872V45.2246H56.9649H53.3971V55.8872ZM66.7171 55.8872V66.5498H70.285H73.8528V55.8872V45.2246H70.285H66.7171V55.8872Z",
    fill: "url(#paint1_linear_1283_131)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2812 55.8872V66.5498H29.8491H33.417V55.8872V45.2246H29.8491H26.2812V55.8872ZM39.6013 55.8872V66.5498H43.1692H46.737V55.8872V45.2246H43.1692H39.6013V55.8872ZM53.3971 55.8872V66.5498H56.9649H60.5328V55.8872V45.2246H56.9649H53.3971V55.8872ZM66.7171 55.8872V66.5498H70.285H73.8528V55.8872V45.2246H70.285H66.7171V55.8872Z",
    stroke: "url(#paint2_linear_1283_131)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1283_131",
    x: 24.1313,
    y: 43.0746,
    width: 51.8713,
    height: 25.6262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1283_131"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1283_131",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1283_131",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1283_131",
    x1: 31.3719,
    y1: 47.1921,
    x2: 59.2677,
    y2: 79.4136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1283_131",
    x1: 54.0314,
    y1: 48.7788,
    x2: 58.1236,
    y2: 70.0794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusuem);
export default __webpack_public_path__ + "static/media/musuem.25c4d8f413916c07357444dcb6d19795.svg";
export { ForwardRef as ReactComponent };